/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".redirect-text[_ngcontent-%COMP%]{opacity:50%;font-style:italic;margin-top:30px}"];
export { styles as styles };
